import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useGetRequest } from "@/hooks/useGetRequest.tsx";
import apiClient from "@/lib/api/client";

export function useDeleteRequest() {
  const queryClient = useQueryClient();
  const { data: request } = useGetRequest();
  const requestId = request?.id;

  return useMutation({
    mutationFn: async () =>
      apiClient.url(`/requests/${requestId}`).delete().json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["request-list", "request"] });
    },
  });
}
